import React from 'react'
import { t, Trans } from '@lingui/macro'
import { DataTableDashboard } from '../DashboardContentTable/DataTableDashboard';
import { TableBody, TableHeader } from './tableData';
import { PopupPanelDashboard } from '../DashboardContentTable/PopupPanelDashboard';

import { DashboardContentPage } from '../DashboardContentTable';
import { ConfirmDialogDashboard } from '../DashboardContentTable/ConfirmDialogDashboard';
import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';

import { typeDataUsersRowActions } from './index';
import { FiltersDashboard } from '../DashboardContentTable/FiltersDashboard';
import { InputSearch } from '../../../UI/InputSearch/InputSearch';

import { DUsersManagementFilters } from 'components/containers/dashboard/dataUsers/filters';
import { PopupEdit } from 'components/containers/dashboard/dataUsers/popupContents/popupEdit';
import { IdUsersStateDataItem } from 'model/dashboardUsers/dUsersReducer';

import { DUsersManagementActions } from 'components/containers/dashboard/dataUsers/actions';
import { PopupAdd } from 'components/containers/dashboard/dataUsers/popupContents/popupAdd';
import { POSITION_ALLOW_CREATE_USERS, USERPOSITIONS } from 'constants/userPositions';


// Type
export type typeViewDataUsers = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupAdd: boolean
    setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>

    openPopupEdit: boolean
    setOpenPopupEdit: React.Dispatch<React.SetStateAction<boolean>>

    openDeleteDialog: boolean
    setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>
    onDeleteConfirmHandler: () => void
    onDeleteCancelHandler: () => void

    openRecoverDialog: boolean
    setOpenRecoverDialog: React.Dispatch<React.SetStateAction<boolean>>
    onRecoverConfirmHandler: () => void
    onRecoverCancelHandler: () => void

    searchValue: string
    onChangeSearchValue: (e: ( React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> )) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    rowsActions: typeDataUsersRowActions

    currentItem: IdUsersStateDataItem | undefined

    pagination: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
    position: USERPOSITIONS | null | undefined
}
// Component
export const ViewDataUsers: React.FC<typeViewDataUsers> = (
    {
        variant,
        setSidebarOpen,
        openFilterBar, setOpenFilterBar,
        pagination,
        openPopupAdd, setOpenPopupAdd,
        openPopupEdit, setOpenPopupEdit,
        openDeleteDialog, setOpenDeleteDialog,
        onDeleteConfirmHandler, onDeleteCancelHandler,

        openRecoverDialog, setOpenRecoverDialog,
        onRecoverConfirmHandler, onRecoverCancelHandler,
        searchValue, onChangeSearchValue,
        onClearSearch, onEnterSearch,

        rowsActions,
        currentItem,
        isActiveFilters, setIsActiveFilters,
        position
    }
) => {
    return (
        <DashboardContentPage
            headerTitle={ <Trans>Staff management</Trans> }
            setSidebarOpen={ setSidebarOpen }
            actions={ ( position && POSITION_ALLOW_CREATE_USERS.includes(position) ) ?
                <DUsersManagementActions onClickAdd={ () => setOpenPopupAdd(true) }/> : undefined }
        >
            {/* Filter bar */ }
            <FiltersDashboard
                variant={ variant }
                filters={ {
                    filtersForm: <DUsersManagementFilters setOpenFilterBar={ setOpenFilterBar }
                                                          setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                } }
                searchBar={ <InputSearch
                    id="userNameSearch"
                    name="userNameSearch"
                    placeholder={ t`Search by name` }
                    value={ searchValue }
                    onChange={ onChangeSearchValue }
                    onClear={ onClearSearch }
                    onKeyEnterDown={ onEnterSearch }
                /> }
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */ }
            <DataTableDashboard
                tableHeader={ <TableHeader/> }
                tableBody={ <TableBody variant={ variant } rowsActions={ rowsActions }/> }
                pagination={ pagination }
            />

            {/* Popup Add item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Add user</Trans> }
                openPopup={ openPopupAdd }
                setOpenPopup={ setOpenPopupAdd }
            >
                <PopupAdd setOpenPopup={ setOpenPopupAdd } variant={ variant }/>
            </PopupPanelDashboard>


            {/* Popup Edit item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Edit</Trans> }
                openPopup={ openPopupEdit }
                setOpenPopup={ setOpenPopupEdit }
            >
                <PopupEdit setOpenPopup={ setOpenPopupEdit } variant={ variant }/>
            </PopupPanelDashboard>

            {/* Item Delete dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="error"
                title={ <Trans>Delete employee</Trans> }
                message={ <Trans>Are you sure you want to delete this employee <b>{ currentItem?.name }</b>?</Trans> }
                primaryButton={ { title: <Trans>Delete</Trans>, action: onDeleteConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onDeleteCancelHandler } }
                openDialog={ openDeleteDialog }
                setOpenDialog={ setOpenDeleteDialog }
            />

            {/* Item Recover dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="info"
                title={ <Trans>Recover user</Trans> }
                message={ <Trans>Do you really want recover user <b>{ currentItem?.name }</b>?</Trans> }
                primaryButton={ { title: <Trans>Recover</Trans>, action: onRecoverConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onRecoverCancelHandler } }
                openDialog={ openRecoverDialog }
                setOpenDialog={ setOpenRecoverDialog }
            />


        </DashboardContentPage>
    )
}
